import querystring from "querystring";
import React, { useEffect, useState } from "react";
import { AnalyticsProvider, emitMigrationModalAction, emitMigrationModalImpression, useExperiment, } from "@catchoftheday/analytics";
import { Box, Flex, Heading, IconOnePass, Image, Link, LinkButton, Modal, Text, } from "@catchoftheday/cg-components";
import { useCustomerQuery } from "@catchoftheday/customer";
import { withApollo } from "@catchoftheday/graphql-utils";
import { cookies, getCookie } from "@catchoftheday/utilities";
import { ASSET_WOMAN_HANDS_UP_WITH_ONEPASS_LIGHT_BG, ASSET_WOMAN_HANDS_UP_WITH_ONEPASS_LIGHT_BG_LANDSCAPE, COOKIE_ONEPASS_MIGRATION_MODAL_KEY, ONEPASS_MIGRATION_MODAL_EXPERIMENT, URL_ONEPASS_PUBLIC_MIGRATION, } from "../../consts";
import { useIsMobile } from "../../hooks";
import { generateOnePassConsentUrl, isEligibleForOnePassMigration, } from "../../utilities";
import { BenefitItem } from "./BenefitItem";
import { BENEFITS } from "./benefits";
export const OnePassMigrationModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [currentPathname, setCurrentPathname] = useState("/");
    const [currentQuery, setCurrentQuery] = useState({});
    const handleSetCookie = () => {
        cookies.set(COOKIE_ONEPASS_MIGRATION_MODAL_KEY, "true", {
            expires: 30,
        });
    };
    const openModal = () => {
        emitMigrationModalImpression();
        setIsOpen(true);
    };
    const closeModal = () => {
        handleSetCookie();
        emitMigrationModalAction("close");
        setIsOpen(false);
    };
    const handleCTAClick = () => {
        handleSetCookie();
        emitMigrationModalAction("click");
    };
    const { variants: [experiment], loading: experimentLoading, } = useExperiment([ONEPASS_MIGRATION_MODAL_EXPERIMENT]);
    const { data: customerData, loading: customerLoading } = useCustomerQuery({
        ssr: false,
    });
    useEffect(() => {
        if (typeof globalThis !== "undefined") {
            setCurrentPathname(globalThis.location.pathname);
            setCurrentQuery(querystring.parse(globalThis.location.search.substring(1)));
        }
    }, []);
    useEffect(() => {
        const cookie = getCookie(COOKIE_ONEPASS_MIGRATION_MODAL_KEY, false);
        if (!experimentLoading &&
            experiment?.bucket === 1 &&
            !customerLoading &&
            isEligibleForOnePassMigration(customerData?.customer) &&
            !cookie) {
            openModal();
        }
    }, [
        customerData?.customer,
        customerLoading,
        experiment?.bucket,
        experimentLoading,
    ]);
    const isMobile = useIsMobile();
    return (<Modal isOpen={isOpen} maxWidth="960px" width="90%" zIndex={101} closeButtonProps={{
            position: "absolute",
            top: "20px",
            right: 0,
            bg: "transparent",
            width: "36px",
            height: "36px",
        }} closeIconProps={{
            width: "16px",
            height: "16px",
            color: "onePass.textPrimary",
        }} onRequestClose={() => {
            closeModal();
        }} contentProps={{
            height: "auto",
            padding: 0,
        }} enableDefaultResponsiveStyles={false}>
      <Flex flexWrap="wrap" alignItems="center">
        <Box width={{
            xs: "100%",
            md: "50%",
        }} overflow="hidden">
          <Image width={{
            xs: "100%",
            md: "auto",
        }} height={{
            xs: "auto",
            md: "100%",
        }} src={isMobile
            ? ASSET_WOMAN_HANDS_UP_WITH_ONEPASS_LIGHT_BG_LANDSCAPE
            : ASSET_WOMAN_HANDS_UP_WITH_ONEPASS_LIGHT_BG} alt="Woman raising hands up in the air with OnePass background"/>
        </Box>
        <Box width={{
            xs: "100%",
            md: "50%",
        }} py={{
            xs: 6,
            md: 9,
        }} px={{
            xs: 4,
            md: 9,
        }} color="onePass.textPrimary" fontFamily="onePass">
          <Heading.h3 m={0} mb={4} fontWeight="bold">
            <IconOnePass color="onePass.primary" height="20px" width="auto" mr="6px" title="OnePass" aria-label="OnePass" marginBottom="7px"/>
            has moved to a new location
          </Heading.h3>
          <Box fontSize="sm" fontWeight="medium">
            <Text m={0} mb={4} fontWeight="inherit">
              Follow the steps to securely transfer your subscription to the new
              OnePass.
            </Text>
            <Text m={0} fontWeight="bold">
              You'll get access to:
            </Text>
            {BENEFITS.map(({ icon, description }, idx) => (<BenefitItem key={`migration-benefit-${idx}`} icon={icon}>
                {description}
              </BenefitItem>))}
          </Box>
          <LinkButton href={generateOnePassConsentUrl(currentPathname, currentQuery)} variant="onePassPrimary" sizeVariant="sm" fontWeight="bold" mb={2} mt={4} onClick={handleCTAClick}>
            Transfer to the new OnePass
          </LinkButton>
          <Box textAlign="center" mb={4}>
            <Link href={URL_ONEPASS_PUBLIC_MIGRATION} color="onePass.primary" hoverColor="onePass.primaryDarker" textDecoration="underline" fontSize="xs" fontWeight="bold" onClick={handleSetCookie}>
              Find out more
            </Link>
          </Box>
          <Text fontSize="xs" textAlign="center" fontWeight="medium" color="textTertiary" m={0}>
            *Excludes bulky, special order and marketplace items
          </Text>
        </Box>
      </Flex>
    </Modal>);
};
export const OnePassMigrationModalWithApollo = withApollo({
    uri: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT,
})(() => (<AnalyticsProvider>
    <OnePassMigrationModal />
  </AnalyticsProvider>));
